import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { memo as o } from "react";
import { u as i } from "../styled-components.browser.esm-3eb04950.js";
const m = o(({ className: r = "", loading: t = !0, children: s }) => /* @__PURE__ */ a(n, { className: r, children: [
  t && /* @__PURE__ */ e("svg", { className: "spinner", viewBox: "0 0 50 50", children: /* @__PURE__ */ e("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5", stroke: "var(--primary)" }) }),
  s || /* @__PURE__ */ e("div", {})
] })), n = i.div`
  .spinner {
    animation: rotate 2s linear infinite;
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -25px 0 0 -25px;
    width: 35px;
    height: 35px;

    & .path {
      stroke: hsl(210, 70%, 75%);
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }

  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;
export {
  m as default
};
//# sourceMappingURL=Loader.js.map
